var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/shopping-cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4 4.5H6.66667L7.2 7.16667M9.33333 17.8333H22.6667L28 7.16667H7.2M9.33333 17.8333L7.2 7.16667M9.33333 17.8333L6.27614 20.8905C5.43619 21.7305 6.03108 23.1667 7.21895 23.1667H22.6667M22.6667 23.1667C21.1939 23.1667 20 24.3606 20 25.8333C20 27.3061 21.1939 28.5 22.6667 28.5C24.1394 28.5 25.3333 27.3061 25.3333 25.8333C25.3333 24.3606 24.1394 23.1667 22.6667 23.1667ZM12 25.8333C12 27.3061 10.8061 28.5 9.33333 28.5C7.86057 28.5 6.66667 27.3061 6.66667 25.8333C6.66667 24.3606 7.86057 23.1667 9.33333 23.1667C10.8061 23.1667 12 24.3606 12 25.8333Z",
    stroke: "#737791",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOrders);
export default __webpack_public_path__ + "static/media/sidebar_orders.815768c1cec5161aec67db22b69447c9.svg";
export { ForwardRef as ReactComponent };